var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBlueBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1407,
  height: 602,
  viewBox: "0 0 1407 602",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  filter: "url(#svg-public/img/nestleLanding/blue-background.svg__filter0_f_976_14984)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1207 301C1207 340.206 934.693 402 713.339 402C491.984 402 200 326.704 200 301C200 262.833 491.984 200 713.339 200C934.693 200 1207 270.882 1207 301Z",
  fill: "url(#svg-public/img/nestleLanding/blue-background.svg__paint0_linear_976_14984)",
  fillOpacity: 0.7
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/nestleLanding/blue-background.svg__filter0_f_976_14984",
  x: 0,
  y: 0,
  width: 1407,
  height: 602,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 100,
  result: "effect1_foregroundBlur_976_14984"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/nestleLanding/blue-background.svg__paint0_linear_976_14984",
  x1: 1114.14,
  y1: 301.26,
  x2: 325.659,
  y2: 301.26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#90ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51745,
  stopColor: "#228DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#90ECFF"
})))));
export { SvgBlueBackground as ReactComponent };